<div class="page-ib">
  <div class="row">
    <div class="col">
      <fx-page-header
        title="{{ detail ? 'Balance Details' : 'MAM/PAMM Follower' }}"
        [backButton]="detail"
        (back)="detail = null"
      ></fx-page-header>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <ng-container *ngIf="!detail; else ibDetail">
        <fx-mam-list
          (selectMAM)="onSelectedMAM($event)"
          [permission]="permission"
        ></fx-mam-list>
      </ng-container>
      <ng-template #ibDetail>
        <fx-mam-detail [login]="detail.login" [permission]="permission"></fx-mam-detail>
      </ng-template>
    </div>
  </div>
</div>
